<template>
    <div>
      <Header class="black"></Header>
      <div class="per-set" style="min-height: 678px">
        <ul>
          <li v-for="(item,index) in menuList" @click="liClick(index)">
            <router-link :to="item.path" :class="{'menu-active':!$route.path.indexOf(item.path)}">
              <Icon :type="item.icon"></Icon>
              {{item.name}}
            </router-link>
          </li>
        </ul>
        <div class="per-con">
          <router-view></router-view>
        </div>
      </div>
      <Footer></Footer>
    </div>
</template>

<script>
    import '@/assets/js/common'
    import Header from  '@/components/Header'
    import Footer from  '@/components/Footer'
    export default {
      name: "person",
      components:{
        Header,Footer
      },
      data () {
        return {
          menuList: [
            {
              name:'我的钱包',
              path:'/wallet',
              icon:'card'
            },
            {
              name:'账户管理',
              path:'/personal',
              icon:'person'
            },
            {
              name:'账单明细',
              path:'/bill',
              icon:'ios-paper'
            }
          ],
          current:0
        }
      },
      methods:{
        liClick(index){
          this.current=index;
          console.log(this.$route.path);
        }
      }
    }
</script>

<style scoped>
  .per-set{
    padding-top: 80px;
    width: 1200px;
    margin: 0 auto;
    overflow: hidden;
    background: #f5f5f5;
  }
  .per-set ul{
    overflow: hidden;
    width: 260px;
    height: 330px;
    float: left;
    background: #fff;
  }
  .per-set ul li{
    margin: 16px 0;
    height: 62px;
    line-height: 62px;
  }
  .per-set ul li a{
    padding-left: 26px;
    font-size: 18px;
    border-left: 2px solid #fff;
    vertical-align: middle;
    color: #424753;
  }
  .per-set ul li a:hover,.menu-active{
    color:#3E87FF !important;
    border-left: 2px solid #3E87FF !important;
  }
  .per-con{
    width: 920px;
    margin-left: 20px;
    float: left;
  }
</style>



// WEBPACK FOOTER //
// person.vue?b98320aa